<template>
    <el-aside class="el-leftside" style="width: 200px;">

        <div class="logo-container">
            <!-- Logo 图片或文字 -->
            <img :src="logoRaw" alt="logo" class="logo-image" />
        </div>
        
        <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;" v-if="displayCollapseBtn">
            <el-radio-button :label="false">展开</el-radio-button>
            <el-radio-button :label="true">收起</el-radio-button>
        </el-radio-group>

        <el-menu default-active="/home/dashboard" active-text-color="#6954f0" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="selectMenuItem" :collapse="isCollapse">
            <el-submenu v-for="(item, index) in mapMenuNavs" :key="item.index" :index="item.index">
                <template slot="title">
                    <i :class="item.icon"></i>
                    <span slot="title">{{ item.name }}</span>
                </template>
                <el-menu-item v-for="(key, i) in item.items" :index="key.index" class="child-menu-title"><i :class="key.icon"></i>{{ key.name }}</el-menu-item>
            </el-submenu>
        </el-menu>

    </el-aside>
</template>

<script>
export default {
  name: 'header_nav_menu',
  data() {
    return {
        logoRaw: require("../assets/simiconlogo.png"),
        isCollapse: false,
        displayCollapseBtn: false,
        mapMenuNavs: [
            {
                index: "1",
                id: "a",
                name: "SIM卡管理",
                icon: "el-icon-bank-card",
                items: [
                    {
                        index: "/sims/manage",
                        id: "a1",
                        name: "SIM卡管理",
                        icon: "el-icon-connection",
                    },
                    {
                        index: "/gmsims/manage",
                        id: "a2",
                        name: "国际卡管理",
                        icon: "el-icon-connection",
                    },
                    {
                        index: "/sims/imports",
                        id: "a3",
                        name: "导入卡",
                        icon: "el-icon-connection",
                    },
                    {
                        index: "/renewals/order",
                        id: "a4",
                        name: "续费记录",
                        icon: "el-icon-coin",
                    },
                    {
                        index: "/sims/sms_manage",
                        id: "a5",
                        name: "短信管理",
                        icon: "el-icon-chat-square",
                    },
                    {
                        index: "/cardsource/manage",
                        id: "a6",
                        name: "卡源管理",
                        icon: "el-icon-coin",
                    }
                ]
            },
            {
                index: "2",
                id: "b",
                name: "客户管理",
                icon: "el-icon-office-building",
                items: [
                    {
                        index: "/hold/manage",
                        id: "b1",
                        name: "组织管理",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/user/manage",
                        id: "b2",
                        name: "账号管理",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/hold/api_manage",
                        id: "b3",
                        name: "中间件管理",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "3",
                id: "c",
                name: "套餐管理",
                icon: "el-icon-price-tag",
                items: [
                    {
                        index: "/package/manage",
                        id: "c1",
                        name: "套餐列表",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/package/price_config",
                        id: "c2",
                        name: "套餐价格配置",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/package/rechargelist",
                        id: "c3",
                        name: "套餐续费权限",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "4",
                id: "d",
                name: "流量池监控",
                icon: "el-icon-money",
                items: [
                    {
                        index: "/foodmtr/manage",
                        id: "d1",
                        name: "总池流量监控",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/foodmtr/manage1",
                        id: "d2",
                        name: "流量池预警订阅",
                        icon: "el-icon-document",
                    },
                    {
                        index: "/foodmtr/manage2",
                        id: "d3",
                        name: "异常数据",
                        icon: "el-icon-document",
                    }
                ]
            },
            {
                index: "7",
                id: "j",
                name: "系统管理",
                icon: "el-icon-setting",
                items: [
                    {
                        index: "/syslogs/manage",
                        id: "j2",
                        name: "操作日志",
                        icon: "el-icon-document",
                    }
                ]
            }
        ]
    }
  },
  methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      selectMenuItem(index, indexPath) {
        //console.log(`index=${index}, indexPath=${indexPath}`);
        this.$router.push(index);

        var obj = {};
        for(var i=0; i<this.mapMenuNavs.length; i++) {
            for(var j=0; j<this.mapMenuNavs[i].items.length; j++) {
                if(this.mapMenuNavs[i].items[j].index === index) {
                    obj = {
                        id: this.mapMenuNavs[i].items[j].id,
                        name: this.mapMenuNavs[i].items[j].name,
                        path: this.mapMenuNavs[i].items[j].index
                    };
                    break;
                }
            }
        }

        this.$emit('eventSelectItemPath', obj);
        
      }
    }
}
</script>

<style scoped>
.el-leftside {
    width: 200px;
    height: 100vh;
    z-index: 800;
    background-color: #ffffff;
    text-align: left;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
}
</style>